import { Pipe, PipeTransform } from '@angular/core';
import * as VMasker from 'vanilla-masker';

@Pipe({
    name: 'cpfcnpj',
})
export class CpfCnpjPipe implements PipeTransform {

    public transform(value: any): any {
        if (!value) return null;

        const newValue = value.toString();
        const normalizedValue = newValue.replace(/[_\W]+/g, '');
        
        // CPF - mantém lógica original
        if (normalizedValue.length <= 11) {
            return VMasker.toPattern(normalizedValue, '999.999.999-99?9');
        }
        
        // CNPJ - suporta alfanumérico
        return VMasker.toPattern(normalizedValue.toUpperCase(), 'SS.SSS.SSS/SSSS-99');
    }

}
